import { AloBase, getDefaultAloBase } from "./AloBase"


export interface AloSection extends AloBase  {        
    image:string,
    url:string,    
    sectionId:number,
    pageId:number
}

export const getDefaultAloSection = ():AloSection => {
    return {
        ...getDefaultAloBase(),
        image:'',
        url:'',
        sectionId:-1,
        pageId:-1
    }
}